import { render, staticRenderFns } from "./ExploreSetup.vue?vue&type=template&id=2a8e501f&scoped=true"
import script from "./ExploreSetup.vue?vue&type=script&lang=js"
export * from "./ExploreSetup.vue?vue&type=script&lang=js"
import style0 from "./ExploreSetup.vue?vue&type=style&index=0&id=2a8e501f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e501f",
  null
  
)

export default component.exports